<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" (dateRangeUpdate)="toggleLayer(isActive)">
</eaglei-leaflet-layer-header>
